module.exports = __webpack_public_path__ + "static/mouse-wheel-1718e84777b9a3b054b259ba5d2a3183.gif";